import { render, staticRenderFns } from "./addCheck.vue?vue&type=template&id=274c1491&scoped=true&"
import script from "./addCheck.vue?vue&type=script&lang=ts&"
export * from "./addCheck.vue?vue&type=script&lang=ts&"
import style0 from "./addCheck.vue?vue&type=style&index=0&id=274c1491&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274c1491",
  null
  
)

export default component.exports